/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vp_Blocked_GenericInputs */



/**
* | output |
* | --- |
* | "These victory points cannot be scored as entered." |
*
* @param {Vp_Blocked_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_blocked_generic = /** @type {((inputs?: Vp_Blocked_GenericInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_Blocked_GenericInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ces VP ne peuvent pas être notés tels quels.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estos VP no se pueden puntuar tal como están introducidos.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Estes VP não podem ser pontuados como foram introduzidos.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questi VP non possono essere registrati così come sono.")
	return /** @type {LocalizedString} */ ("These victory points cannot be scored as entered.")
});